export default "__VITE_ASSET__DltiSM7N__"